import { useRecoilValue } from 'recoil';

import { useGetMyUncheckedQuestionQuery } from '@/hooks/qna/mobile/qna.gql.impl';
import { tokenState } from '@/recoil/atoms/common/auth';
import { AiAnswerStatus, QuestionStatus } from '@/types/bff/gql-schema';

interface useGetMyUncheckedAiAnswerReturn {
  unCheckedMyAiQuestion: () => void;
  aiAnswerStatus: AiAnswerStatus;
  questionPid: string;
  status: QuestionStatus;
}
const useGetMyUncheckedAiAnswer =
  (): useGetMyUncheckedAiAnswerReturn | null => {
    const token = useRecoilValue(tokenState);
    const { data, refetch } = useGetMyUncheckedQuestionQuery(
      {},
      {
        useErrorBoundary: false,
        refetchOnWindowFocus: true,
        retry: 0,
        enabled: !!token,
      },
    );

    const unCheckedMyAiQuestion = async () => {
      await refetch();
    };

    if (!data?.myUncheckedQuestion) {
      return null;
    }

    const { aiAnswerStatus, questionPid, status } = data.myUncheckedQuestion;

    return {
      aiAnswerStatus,
      questionPid,
      unCheckedMyAiQuestion,
      status,
    };
  };

export default useGetMyUncheckedAiAnswer;
